import { render } from "./ListaModelos.vue?vue&type=template&id=248180a0"
import script from "./ListaModelos.vue?vue&type=script&lang=js"
export * from "./ListaModelos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__